export const listCategory = [
  {
    category: 'o2o_unclear_reason_from_user',
    type: {
      'unclear_reason_from_user': 'Komplain Umum',
    },
    icon: 'IcoChat',
    color: '#4F78E8',
  }, {
    category: 'o2o_company_marketing',
    type: {
      'promotional_campaigns': 'Promo',
      'government_collaboration': 'Prakerja dan Pemerintah',
      'product_discounts': 'Promo Diskon',
      'sales_army': 'Hubungan dengan Sales',
      'mitra_juwara': 'Promo Juwara',
      'uncat': 'Komplain seputar promo'
    },
    icon: 'IcoVoucher',
    color: '#128C55'
  }, {
    category: 'o2o_account',
    type: {
      'registration_activation': 'Pendaftaran & Registrasi',
      'change_phone_number': 'Ubah no. Handphone',
      'premium_mitra': 'Premium Mitra',
      'uncat': 'Akun'
    },
    icon: 'IcoUser',
    color: '#4F78E8'
  }, {
    category: 'o2o_payment',
    type: {
      'order_payment': 'Pembayaran Transaksi',
      'dana_saldo_mitra': 'DANA & Saldo Mitra',
      'mitra_point': 'Poin Mitra',
      'kirim_uang': 'Kirim Uang',
      'setor_tunai': 'Setor Tunai',
      'promocode_voucher_cashback': 'Promo & Voucher',
      'qris': 'QRIS',
      'uncat': 'Pembayaran'
    },
    icon: 'IcoBill',
    color: '#FAB801'
  }, {
    category: 'o2o_wholesale_ordering',
    type: {
      'assortment_stock': 'Stok Barang',
      'ordering': 'Pembelian Grosir',
      'uncat': 'Grosir'
    },
    icon: 'IcoCart',
    color: '#FB8B01'
  }, {
    category: 'o2o_wholesale_shipping_delivery',
    type: {
      'shipping': 'Pengiriman Grosir',
      'delivery': 'Pengiriman Grosir',
      'uncat': 'Pengiriman'
    },
    icon: 'IcoCart',
    color: '#FB8B01'
  }, {
    category: 'o2o_returns_refund',
    type: {
      'wholesale_product_return': 'Pengembalian Barang Grosir',
      'refund': 'Pengembalian Saldo',
      'uncat': 'Pengembalian'
    },
    icon: 'IcoCash',
    color: '#128C55'
  }, {
    category: 'o2o_financial_services_virtual_products',
    type: {
      'virtual_product': 'Produk Virtual',
      'bukaemas': 'BukaEmas',
      'saldo_bantuan': 'Saldo Bantuan',
      'angsuran_kredit': 'Angsuran Kredit',
      'mitra_commission': 'Komisi Mitra',
      'uncat': 'Komplain Produk Virtual'
    },
    icon: 'IcoBill',
    color: '#FAB801'
  }, {
    category: 'o2o_fraud_policy_security',
    type : {
      'fraud': 'Pelanggaran Ketentuan',
      'security': 'Keamanan Akun',
      'uncat': 'Komplain Keamanan'
    },
    icon: 'IcoLock',
    color: '#3D3D3D'
  }, {
    category: 'o2o_web_app_improvement',
    type: {
      'performance_stability': 'Performa Aplikasi',
      'suggestions': 'Saran untuk Aplikasi',
      'uncat': 'Komplain seputar aplikasi'
    },
    icon: 'IcoPhoneAndroid',
    color: '#4F78E8'
  }, {
    category: 'o2o_marketplace',
    type: {
      'marketplace': 'Komplain Bukalapak'
    },
    icon: 'IcoChat',
    color: '#4F78E8'
  }
];

export default listCategory;
